import { Box, Button } from '@mui/material';
import { FC } from 'react';

import { useVerifyAnotherCompany } from '../../hooks/use-verify-another-company';

const VerifyAnotherCompanyButton: FC = () => {
  const { showVerifyAnotherButton, handleVerifyAnotherClick } = useVerifyAnotherCompany();

  if (!showVerifyAnotherButton) {
    return null;
  }

  return (
    <Box mt={4} display="flex" justifyContent="center">
      <Button variant="contained" color="primary" size="large" onClick={handleVerifyAnotherClick}>
        Verify another company
      </Button>
    </Box>
  );
};

export { VerifyAnotherCompanyButton };
